import React from 'react';
import { useFormContext } from 'react-hook-form';
import './style.scss';

export default function ConfigAdminFee() {
  const { register, getValues } = useFormContext() || {};
  return (
    <div className="option-row__input-wrap">
      <span className="fee-input__prefix">$</span>
      <div className="fee-input">
        <input
          type="number"
          id="admin-fee-input"
          placeholder="0.00"
          step="0.50"
          min="0"
          className="fee-input__field"
          defaultValue={getValues ? getValues('adminCost') : ''}
          {...(register ? register('adminCost') : {})}
        />
      </div>
      <span className="option-row__suffix">per order</span>
    </div>
  );
}
